import React from 'react'
import { IndeedFlexOtpProvider } from './context/IndeedFlexOtpProvider'
import { IndeedFlexOtpMain } from './components/IndeedFlexOtpMain'

export const IndeedFlexOtp = () => {
  return (
    <IndeedFlexOtpProvider>
      <IndeedFlexOtpMain />
    </IndeedFlexOtpProvider>
  )
}
